import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RecurringPaymentRowData } from '../recurring-payment-card-data';

@Component({
  selector: 'app-vb-payments-recurring-payment-row',
  templateUrl: './vb-payments-recurring-payment-row.component.html',
  styleUrls: ['./vb-payments-recurring-payment-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsRecurringPaymentRowComponent {
  @Input({ required: true }) row!: RecurringPaymentRowData;
  @Input({ required: true }) frequencyLabel!: string;
}
